import { render, staticRenderFns } from "./EditTextMore.vue?vue&type=template&id=6715f936&scoped=true&"
import script from "./EditTextMore.vue?vue&type=script&lang=js&"
export * from "./EditTextMore.vue?vue&type=script&lang=js&"
import style0 from "./EditTextMore.vue?vue&type=style&index=0&id=6715f936&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6715f936",
  null
  
)

export default component.exports